// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"475":"e846f881","760":"0333b07b"}[chunkId] + ".chunk.css";
};